export type { BlockHashType } from "./BlockHashType.js";
export * from "./errors.js";

import { equals as _equals } from "./equals.js";
import { from as _from } from "./from.js";
import { fromBytes as _fromBytes } from "./fromBytes.js";
import { fromHex as _fromHex } from "./fromHex.js";
import { toHex as _toHex } from "./toHex.js";

export const from = _from;
export const fromBytes = _fromBytes;
export const fromHex = _fromHex;
export const toHex = _toHex;
export const equals = _equals;
